import { render } from "./MocksRecord.vue?vue&type=template&id=749cc264&scoped=true"
import script from "./MocksRecord.vue?vue&type=script&lang=js"
export * from "./MocksRecord.vue?vue&type=script&lang=js"

import "./MocksRecord.vue?vue&type=style&index=0&id=749cc264&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-749cc264"]])

export default __exports__